<template>
    <div>

        <div class="modal fade" :class="{
            in: active,
            'modal-fullscreen': options.fullscreen === true,
          }"
             @keyup.esc="validateFoodAndHideModal()"
             tabindex="0">
            <div class="modal-dialog"
                 :class="{
                    'modal-lg': options.large === true,
                    'no-draggable': options.nodraggable === true
                }">
                <div class="modal-content" v-if="component">
                    <div>
                        <component :is="component" @keyup.esc="this.validateFoodAndHideModal()">
                            <template slot="prevModal">
                                <button class="btn btn-primary pull-left" @click="prevModal()" v-if="modals.length > 1">
                                  <i aria-hidden="true" class="fa fa-arrow-circle-left"></i>
                                  Wróć
                                </button>
                            </template>
                            <template slot="modalHeader">
                                <button type="button" @click="hideModal" class="close">
                                    &times;
                                </button>
                            </template>
                        </component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" type="text/scss">

    .modal-open {
        overflow: hidden !important;

    }

    .body {
        overflow: hidden !important;
    }

    .in {
        display: block;
    }

    .modal-header {
        padding: 7px 15px;
    }

    .modal-dialog {
        overflow-y: initial !important;
        font-size: 14px;
        position: relative;
        z-index: 9999;
    }

    .modal-fullscreen {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: hidden;

        .modal-dialog {
            position: fixed;
            margin: 0;
            width: 100%;
            height: 100%;
            padding: 0;
        }

        .modal-content {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            border-radius: 0;
            box-shadow: none;
        }

        .modal-header {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
        }

        .modal-body {
            position: absolute;
            top: 40px;
            bottom: 0;
            width: 100%;
            overflow: auto;
        }

        .modal-footer {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            height: 65px;
        }

    }
</style>

<script>
    import {mapMutations, mapState} from 'vuex';
    import {invalidFoodExists} from "../services/invalidFoodChecker";

    export default {
        data() {
            return {
                component: null,
                options: {
                    large: false,
                    nodraggable: false,
                    fullscreen: false
                },
            };
        },
        created() {
            document.addEventListener('keyup', this.close);
        },
        destroyed() {
            document.removeEventListener('keyup', this.close);
        },
        computed: {
            ...mapState({
                active: state => state.modal.visible,
                modalComponent: state => state.modal.component,
                modalOptions: state => state.modal.options,
                modals: state => state.modals,
                schema: state => state.menu.schema,
            }),
        },

        methods: {
            ...mapMutations(['hideModal', 'showModal']),
            close(e) {
                if (e.keyCode === 27) {
                    if (this.component === 'edit-food-modal' && invalidFoodExists(this.schema)) {
                        return;
                    }
                    this.hideModal();
                }
            },

            prevModal() {
                if (this.component === 'edit-food-modal' && invalidFoodExists(this.schema)) {
                    return;
                }
                this.modals.pop();
                this.showModal(this.modals.pop());
            },
            validateFoodAndHideModal() {
                if (this.component === 'edit-food-modal' && invalidFoodExists(this.schema)) {
                    return;
                }
                this.hideModal();
            },
        },
        watch: {
            modalComponent(componentName) {
                if (!componentName) return;

                this.component = componentName;
            },
            modalOptions(options) {
              this.options = options || {
                large: false,
                nodraggable: false,
                fullscreen: false
              };
            },
        },
    };
</script>
